module.exports = __webpack_public_path__ + "img/gallery.08d13224.svg";